import React from "react";

const InputSelectList = (props) => {
	const onChange = (event) => {
		props.setValue(event.target.value);
	};
	return (
		<div className="form-group boxed">
			<div className="input-wrapper">
				<label className="label">{props.label}</label>
				<select className="form-control custom-select" value={props.value} onChange={onChange} required>
					{props.defaultValueLabel !== null && (
						<option disabled value="">
							{props.defaultValueLabel}
						</option>
					)}
					{props.valueList.map((v) => (
						<option key={v.key} value={v.value}>
							{v.key}
						</option>
					))}
				</select>
				{props.validFeedback && <div className="valid-feedback">{props.validFeedback}</div>}
				{props.invalidFeedback && <div className="invalid-feedback">{props.invalidFeedback}</div>}
			</div>
		</div>
	);
};

InputSelectList.defaultProps = {
	valueList: [],
	value: "",
	defaultValueLabel: null,
	label: "",
};
export default InputSelectList;
